import {
  useMemo } from "react";
  import { useTranslation } from "react-i18next";
  import {
  ShopOutlined,
  ClusterOutlined,
  CarOutlined,
  RiseOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByIndex: Record<number, JSX.Element> = {
  0: <ShopOutlined />,
  1: <ClusterOutlined />,
  2: <CarOutlined />,
  3: <DollarOutlined />,
};

const BenefitsSection = () => {
  const { t } = useTranslation("dms");

  const items = useMemo(() => {
    const raw = t("benefits.items", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ title: string; desc: string }>;
  }, [t]);

  return (
    <section className="dev-dms-section dev-dms-benefits-section">
      <div className="dev-dms-section-inner">
        <h2 className="dev-section-h2 dev-dms-section-h2">
          <span className="dev-dms-section-h2-icon dev-dms-section-h2-icon--amber" aria-hidden>
            <RiseOutlined />
          </span>
          <span>{t("benefits.title")}</span>
        </h2>

        <div className="dev-dms-benefits-grid">
          {items.slice(0, 5).map((item, idx) => (
            <div key={idx} className="dev-dms-benefit-card">
              <div className="dev-dms-benefit-left">
                <span className="dev-dms-benefit-number">{String(idx + 1).padStart(2, "0")}</span>
                <span className="dev-dms-benefit-icon">{iconByIndex[idx] ?? null}</span>
              </div>
              <div className="dev-dms-benefit-body">
                <div className="dev-dms-benefit-title">{item.title}</div>
                <div className="dev-dms-benefit-desc">{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
